import { Outlet, Route, Routes, useParams } from 'react-router'
import { Link } from 'react-router-dom'
import { Tab } from '../components/tab'
import { usePageLayout } from '../layouts'

export function Root() {
	return (
		<>
			<Routes>
				<Route path="/" element={<Main />} />
				<Route path="/:id/*" element={<Detail />} />
			</Routes>
			<div className="grow">
				<Outlet />
			</div>
		</>
	)
}

function Main() {
	return (
		<div className="flex items-center gap-4 mb-5">
			<h2 className="text-lg">Seznam</h2>
		</div>
	)
}

function Detail() {
	const { object = '' } = useParams<{ object: string }>()
	const { layout: pageLayout } = usePageLayout(object)

	return (
		<>
			<div className="flex items-center gap-4 mb-5 flex items-center gap-4">
				<Link to="../">←</Link>
				<h2 className="text-lg">Detail</h2>
			</div>
			{pageLayout.subsections ? (
				<div className="flex gap-4 p-4 justify-between items-center">
					<nav className="border-b border-gray-200">
						<ul className="flex -mb-px">
							{pageLayout.subsections.map(subsection => (
								<li key={subsection.path}>
									<Tab to={subsection.path} end>
										{subsection.name}
									</Tab>
								</li>
							))}
						</ul>
					</nav>
				</div>
			) : null}
		</>
	)
}
